import type { FC, ReactNode } from 'react'

import Image from 'next/image'

import { event } from '@/constants/metric'
import { ActionButton } from '@/components/generals/action-button'

export const CtaSection: FC = (): ReactNode => {
    return (
        <section id='cta' aria-labelledby='cta-title' className='px-0 pb-20 tab:px-[60px] tab:pb-28'>
            <div className='fw-container'>
                <div className='relative flex min-h-[420px] items-center justify-center overflow-hidden rounded-[9px] border border-line px-5 py-20 tab:min-h-[520px] tab:px-10'>
                    <div data-parallax='90' className='absolute inset-[-12%]'>
                        <Image
                            src='/images/hero.png'
                            alt=''
                            fill
                            sizes='100vw'
                            className='object-cover'
                        />
                    </div>

                    <span aria-hidden='true' className='absolute inset-0 bg-[#0d0d0d]/35' />

                    <span aria-hidden='true' className='fw-noise absolute inset-0 opacity-[0.08]' />

                    <div className='relative z-[2] flex max-w-[620px] flex-col items-center gap-5 text-center'>
                        <h2
                            id='cta-title'
                            data-reveal='up'
                            className='font-sans text-[36px] font-normal leading-[1em] tracking-[-0.02em] text-ink tab:text-[50px] desk:text-[56px]'
                        >
                            Decide with better numbers
                        </h2>

                        <p
                            data-reveal='up'
                            data-reveal-delay='0.08'
                            className='max-w-[460px] font-body text-[17px] leading-[1.3em] text-ink'
                        >
                            Three days of talks, panels, and workshops with the people who measure things for a living.
                        </p>

                        <div data-reveal='up' data-reveal-delay='0.16' className='pt-2'>
                            <ActionButton href={event.ticketsUrl} variant='solid'>
                                Get tickets
                            </ActionButton>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
